import { hot } from 'react-hot-loader';
import { useTranslation } from 'react-i18next';
import { useModal } from 'react-simple-modal-provider';
import ButtonPrimary from './ButtonPrimary';

import ReactPixel from 'react-facebook-pixel';


function ConnectWalletButton() {
  const { t } = useTranslation();
  //const { open: openWalletConnectModal } = useModal('WalletConnectModal');
  const openWalletConnectModal = () => null;
  const onClick = () => {
    openWalletConnectModal();
    ReactPixel.track('Lead');
  }

  return (
    <ButtonPrimary
      id='connectWallet'
      tag="button" label={t('Connect wallet')}
      onClick={onClick}
    />
  );
};

export default hot(module)(ConnectWalletButton);
